'use client';

import type { Row } from '@tanstack/react-table';
import { ChainUtils } from '@morpho-org/blue-sdk';
import { abbreviateAddress } from '@repo/utils';
import { ButtonLink, type ButtonLinkButtonProps } from '@/components/common/ButtonLink';
import type { DashboardActivityTableFeatures } from '../config/DashboardActivity.config';
import type { LiquidationActivityTableRow } from '../config/DashboardActivity.types';
interface TransactionHashCellProps {
  row: Row<DashboardActivityTableFeatures, LiquidationActivityTableRow>;
}
const TransactionHashCell = ({
  row
}: TransactionHashCellProps) => {
  // 'use no memo': TanStack keeps this object's reference while table state (sorting, rows) changes.
  'use no memo';

  const buttonProps: ButtonLinkButtonProps = {
    variant: 'ghost',
    size: 'default',
    className: 'hover:bg-accent active:bg-accent hover:brightness-100',
    label: abbreviateAddress(row.original.tx.hash)
  };
  const explorerUrl = ChainUtils.getExplorerTransactionUrl(row.original.chainId, row.original.tx.hash);
  return <ButtonLink href={explorerUrl} mode="external" buttonProps={buttonProps} />;
};
export default TransactionHashCell;